import { useEffect, useState } from "react";
import CostManagementPage from "./CostManagementPage";

export default function CostManagementContainer() {
  // const [searchParams, setSearchParams] = useSearchParams();
  // const { nav } = useNavigation();
  const [dailyCosts, setDailyCosts] = useState(false);
  const [budgets, setBudgets] = useState(false);
  let groupedCosts = {};

  // rewrite the data to be grouped by partner_id
  if (dailyCosts && budgets) {
    dailyCosts.forEach((cost) => {
      if (groupedCosts[cost.partner_id]) {
        groupedCosts[cost.partner_id]["costs"].push(cost);
      } else {
        groupedCosts[cost.partner_id] = { costs: [cost] };
      }

      // budgets is an array of obects. find the object with the partner_id that matches the cost.partner_id
      const partnerBudget = budgets.find(
        (budget) => budget.project_id === cost.partner_id,
      );

      groupedCosts[cost.partner_id]["budget"] = partnerBudget;
    });
  }

  // calulate the total cost for each partner
  Object.entries(groupedCosts).forEach(([partnerId, costs]) => {
    let totalCost = 0;
    costs.costs.forEach((cost) => {
      totalCost += cost.daily_cost;
    });
    groupedCosts[partnerId]["totalCost"] = totalCost;
  });

  console.log("groupedCosts: ", groupedCosts);

  return <CostManagementPage groupedCosts={groupedCosts} />;
}
